import { BaseFeature, FeatureType } from '@core/shared/feature';
export class MessagesBaseFeature extends BaseFeature {
  static {
    this.featureInfo = {
      context: {"package":"@common/messages/feature","featureId":"common-messages"},
      abilityActions: false,
      plugins: [{
        forPlatform: 'frontend',
        type: FeatureType.Permanent,
        pluginClassName: 'MessagesFrontendFeature'
      },
      // {forPlatform:'frontend-management', type:FeatureType.Dynamic, pluginClassName:'MessagesFrontendManagementFeature', simpleAbilityCheck:'MANAGER' },
      {
        forPlatform: 'admin',
        type: FeatureType.Permanent,
        pluginClassName: 'MessagesFrontendFeature',
        importFrom: 'frontend'
      }
      // {forPlatform:'backend', type:FeatureType.Permanent, pluginClassName:'MessagesBackendFeature'},
      // {forPlatform:'backend-admin', type:FeatureType.Permanent, pluginClassName:'MessagesBackendAdminFeature'},
      ]
    };
  }
  getSharedDefinition() {
    return {
      routerLinkResolvers: {
        frontend: {}
      }
    };
  }
}